<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Data Management
          </v-toolbar-title>
          <v-spacer></v-spacer>  
          <v-btn 
              @click="exportAllData()"
              outlined
              :disabled="!selectedBrand">
              <v-icon left color='teal'> arrow_circle_up </v-icon> 
              Export All Data 
            </v-btn>
              <input type="file" accept="application/JSON" id="importDataFile" hidden @change="loadImportedFile">
             <v-btn 
              outlined
              @click="uploadFile()">
              <v-icon left color='teal'> arrow_circle_down </v-icon> 
              Import All Data 
            </v-btn>
             <v-btn
              disabled 
              outline
              large
              @click="removeAllData()">
              <v-icon left color='teal'> delete </v-icon> 
              Delete All Data 
            </v-btn>

            <router-link to="/Dashboard">
              <v-btn icon>
                <v-icon class="white--text">close</v-icon>
              </v-btn>
            </router-link>
          </v-toolbar>  
          
          <v-card>
               <v-card>
                   <v-card-title col>
                <v-flex xs8>
                  <v-card-text> 
                     <b class="primary--text font-weight-bold">Customers</b>
                  </v-card-text>
                </v-flex>
                 <v-flex xs2>
                     <v-btn
                    color="blue-grey"
                    class="ma-2 white--text"
                    @click="deleteIndividualDataSet('buyer')"
                    >
                    Delete Customers
                    <v-icon
                        right
                        dark
                    >
                        delete
                    </v-icon>
                </v-btn>
                 </v-flex>
                </v-card-title>
              </v-card>
          </v-card>
      </v-card>
    </v-flex>
     <v-snackbar
      v-model="snackbar"
      top
      color="success"
      :timeout="3000"
    >
   {{snackbarSuccessText}}
    </v-snackbar>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
import { cfirebase } from '../../../services/firebase.js'

export default {
  data () {
    return {
      message: null,
      snackbar: false,
      snackbarSuccessText : '',
    }
  },
  
  watch:{
    
  },
   created () {
    this.$bindAsArray(
      'buyer',
      this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'seller',
      this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'invoice',
      this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear)
    )
    // this.$bindAsArray(
    //   'item',
    //   this.$root.$firebaseRefs.item.orderByChild('brand').equalTo(this.selectedBrand)
    // )
    this.$bindAsArray(
      'firm',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'account',
      this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'loan',
      this.$root.$firebaseRefs.loan.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'staffs',
      this.$root.$firebaseRefs.staffs.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'staff',
      this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'expenses',
      this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'liabilities',
      this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'incomes',
      this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'customerDeposit',
      this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'products',
      this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'invoiceHistory',
      this.$root.$firebaseRefs.invoiceHistory.orderByChild('brandFinYear').equalTo(this.brandFinYear)
    )
     this.$bindAsArray(
      'salarys',
      this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'termsAndConditions',
      this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'provisionExpense',
      this.$root.$firebaseRefs.provisionExpense.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'provisionLiability',
      this.$root.$firebaseRefs.provisionLiability.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'provisionIncome',
      this.$root.$firebaseRefs.provisionIncome.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'itcPayment',
      this.$root.$firebaseRefs.itcPayment.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'godawn',
      this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'godawnTransaction',
      this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'closingDetails',
      this.$root.$firebaseRefs.closingDetails.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'productGroup',
      this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'batchTransaction',
      this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'damageTransaction',
      this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'orders',
      this.$root.$firebaseRefs.orders.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'firmSettings',
      this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'hrs',
      this.$root.$firebaseRefs.hrs.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'productType',
      this.$root.$firebaseRefs.productType.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'estimates',
      this.$root.$firebaseRefs.estimates.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'productSets',
      this.$root.$firebaseRefs.productSets.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'customerPayments',
      this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  computed:{
    ...mapGlobalGetters(['selectedBrand','brandFinYear']),
  },
  destroyed () {
  },
  methods: {
    uploadFile(){
      document.getElementById('importDataFile').click()
    },
    deleteIndividualDataSet(table){
      // if(this.selectedBrand && confirm('Are you sure you want to delete data of ' + table+ '?')) {
      //   let data = this[table].filter(item=> item['brand'] == this.selectedBrand);
      //   data.map((item)=>{
      //     let key = item['.key'];
      //     this.$root.$firebaseRefs[table].child(key).remove();
      //   })
      //   this.snackbar = true;
      //   this.snackbarSuccessText = "Data is successfully Deleted for " + table + ".";
      // }
    },
    loadImportedFile(ev) {
      const file = ev.target.files[0];
      const fr = new FileReader();
        fr.onload = e => {
          const result = JSON.parse(e.target.result);
          const formatted = JSON.stringify(result, null, 2);
          if(confirm("Are you sure you want to import all data?")) {
            this.importAllData(formatted);
          }
        }
        fr.readAsText(file);
    },
    importAllData(data){
      let dataDetails = data['dataDetails'];
      delete data['dataDetails'];
      if(!!this.selectedBrand && dataDetails.brand == this.selectedBrand) {
        Object.keys(data).forEach(table => {
          data[table].map((item)=>{
            let key = item['.key'];
            delete item['.key']
            this.$root.$firebaseRefs[table].child(key).update(item)
          })
        })
        this.snackbar = true;
        this.snackbarSuccessText = "Data is successfully imported.";
      }
    },
    removeAllData(){
      let data = this.getCurrentBrandData();
      if(confirm("Are you sure you want to remove all data?")) {
        Object.keys(data).forEach(table => {
          data[table].map((item)=>{
            let key = item['.key'];
            this.$root.$firebaseRefs[table].child(key).remove();
          })
        })
        this.snackbar = true;
        this.snackbarSuccessText = "Data is successfully Deleted.";
      }
    },
    getCurrentBrandData(){
       if(!!this.selectedBrand) {
          let data = {};
          data['buyer'] = this.buyer.filter(item=> item['brand'] == this.selectedBrand);
          data['seller'] = this.seller.filter(item=> item['brand'] == this.selectedBrand);
          data['invoice'] = this.invoice.filter(item=> item['brand'] == this.selectedBrand);
          data['item'] = this.item.filter(item=> item['brand'] == this.selectedBrand);
          data['firm'] = this.firm.filter(item=> item['brand'] == this.selectedBrand);
          data['account'] = this.account.filter(item=> item['brand'] == this.selectedBrand);
          data['loan'] = this.loan.filter(item=> item['brand'] == this.selectedBrand);
          data['staffs'] = this.staffs.filter(item=> item['brand'] == this.selectedBrand);
          data['staff'] = this.staff.filter(item=> item['brand'] == this.selectedBrand);
          data['expenses'] = this.expenses.filter(item=> item['brand'] == this.selectedBrand);
          data['liabilities'] = this.liabilities.filter(item=> item['brand'] == this.selectedBrand);
          data['incomes'] = this.incomes.filter(item=> item['brand'] == this.selectedBrand);
          data['customerDeposit'] = this.customerDeposit.filter(item=> item['brand'] == this.selectedBrand);
          data['products'] = this.products.filter(item=> item['brand'] == this.selectedBrand);
          data['invoiceHistory'] = this.invoiceHistory.filter(item=> item['brand'] == this.selectedBrand);
          data['salarys'] = this.salarys.filter(item=> item['brand'] == this.selectedBrand);
          data['termsAndConditions'] = this.termsAndConditions.filter(item=> item['brand'] == this.selectedBrand);
          data['provisionExpense'] = this.provisionExpense.filter(item=> item['brand'] == this.selectedBrand);
          data['provisionLiability'] = this.provisionLiability.filter(item=> item['brand'] == this.selectedBrand);
          data['provisionIncome'] = this.provisionIncome.filter(item=> item['brand'] == this.selectedBrand);
          data['itcPayment'] = this.itcPayment.filter(item=> item['brand'] == this.selectedBrand);
          data['godawn'] = this.godawn.filter(item=> item['brand'] == this.selectedBrand);
          data['godawnTransaction'] = this.godawnTransaction.filter(item=> item['brand'] == this.selectedBrand);
          data['closingDetails'] = this.closingDetails.filter(item=> item['brand'] == this.selectedBrand);
          data['productGroup'] = this.productGroup.filter(item=> item['brand'] == this.selectedBrand);
          data['batchTransaction'] = this.batchTransaction.filter(item=> item['brand'] == this.selectedBrand);
          data['damageTransaction'] = this.damageTransaction.filter(item=> item['brand'] == this.selectedBrand);
          data['orders'] = this.orders.filter(item=> item['brand'] == this.selectedBrand);
          data['firmSettings'] = this.firmSettings.filter(item=> item['brand'] == this.selectedBrand);
          data['hrs'] = this.hrs.filter(item=> item['brand'] == this.selectedBrand);
          data['productType'] = this.productType.filter(item=> item['brand'] == this.selectedBrand);
          data['estimates'] = this.estimates.filter(item=> item['brand'] == this.selectedBrand);
          data['productSets'] = this.productSets.filter(item=> item['brand'] == this.selectedBrand);
          data['customerPayments'] = this.customerPayments.filter(item=> item['brand'] == this.selectedBrand);
          return data;
       }
    },
    exportAllData(){
      let data = this.getCurrentBrandData();
      data['dataDetails'] = {
        brand: this.selectedBrand,
        date : new Date().getTime(),
      }
      this.exportToJsonFile(data);
    },
    exportToJsonFile(jsonData) {
      let dataStr = JSON.stringify(jsonData,null,4);
      let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
      let exportFileDefaultName = 'data_'+new Date().toISOString().substr(0, 10)+'.json';
      let linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/DataManagement/dataManagement.vue